<template>
  <div class="container" v-loading.fullscreen.lock="fullScreenLoading">
    <div class="btn-wrapper-1 header">
      <el-button @click="taskModalShow = true" size="mini" type="primary"
        >新建训练任务</el-button
      >
      <el-button @click="refresh" type="primary" size="mini">刷新</el-button>
      <!--<el-button type="primary" @click="emitTrainingTask">查看正在训练任务</el-button>-->
      &nbsp;
      <el-checkbox v-model="onlyHaveModelTasks">只看有模型的任务</el-checkbox>
    </div>
    <filter-wrapper
      :filter-item="{ searchBox: true, canteen: true, eatery: true }"
    ></filter-wrapper>
    <vvTable
      :config="tableConfig"
      :data="taskFilterByDateTime"
      :height="tableHight"
      :itemHeight="55"
    >
      <template slot-scope="scope" slot="status_slot">
        <el-tag
          type="success"
          v-if="scope.row.task_info.status_point === 'finish'"
          size="mini"
          >训练结束</el-tag
        >
        <el-tag
          type="success"
          size="mini"
          v-if="scope.row.task_info.status_point === 'model uploading'"
          >正在上传..</el-tag
        >
        <el-tag
          size="mini"
          type="danger"
          v-if="scope.row.task_info.status_point === 'stop'"
          >已中止</el-tag
        >
        <el-tag
          size="mini"
          type="primary"
          v-if="scope.row.task_info.status_point === 'start'"
        >
          <i class="el-icon-loading"></i>训练中
        </el-tag>
      </template>
      <template slot-scope="scope" slot="cmd_status_slot">
        <el-tooltip
          class="item"
          effect="dark"
          :content="scope.row.task_info.cmd_status_info"
          placement="top-start"
        >
          <el-tag type="primary" size="mini" v-if="scope.row.task_info.cmd_status_info">{{
            scope.row.task_info.cmd_status_info.slice(0, 5) + "..." || ""
          }}</el-tag>
        </el-tooltip>
      </template>
      <template slot-scope="scope" slot="task_desc_slot">{{
        scope.row.task_desc ? scope.row.task_desc : "无备注"
      }}</template>
      <template slot-scope="scope" slot="acc_slot">
        <el-button
          :disabled="scope.row.task_info.status_point !== 'start'"
          class="danger-text"
          type="text"
          size="mini"
          @click="pauseTask(scope, $event)"
          >停止</el-button
        >
        &nbsp;
        <el-popover
          ref="popover1"
          placement="right"
          title
          trigger="click"
          width="500"
        >
          <el-table
            :data="scope.row.task_info.task_acc_list"
            style="width: 100%"
            height="400px"
            max-height="400px"
          >
            <el-table-column header-align="center" align="center" label="key">
              <template slot-scope="scope">{{
                Object.keys(scope.row)[0]
              }}</template>
            </el-table-column>
            <el-table-column
              label="准确率"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">{{
                Object.values(scope.row)[0]
              }}</template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="columnProp"
              label="操作"
            >
              <template slot-scope="scope1">
                <!--:disabled="-->
                <!--scope.row.task_info.stopstatus !== 'stop' ||-->
                <!--scope.row.task_info.status_point === 'finish' ||-->
                <!--scope.row.task_info.status_point === 'model uploading'"-->
                <el-button
                  type="text"
                  size="mini"
                  @click="selectAcc(scope1.row)"
                  >选定</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-button slot="reference" size="mini" type="text"
            >查看准确率</el-button
          >
        </el-popover>
      </template>
      <template slot-scope="scope" slot="class_list_slot">
        <el-popover
          v-if="scope.row.trainModel && scope.row.trainModel.classList"
          ref="popover1"
          placement="top-start"
          trigger="hover"
        >
          <div>
            <span
              class="image-item-wrapper-2"
              :key="dish.dish_url"
              v-for="dish in scope.row.trainModel.classList"
            >
              <img :src="dish.dish_url" class="image-item" alt width="50" />
            </span>
          </div>
          <el-tag slot="reference" size="mini">
            {{ scope.row.trainModel.classList.length }}
          </el-tag>
        </el-popover>
        <span v-else>无模型产出</span>
      </template>
      <template slot-scope="scope" slot="action_slot">
        <span v-if="scope.row.trainModel">
          <span v-if="isChecking(scope.row.task_uuid)">
            <el-button type="success" size="mini" @click="viewResult(scope.row)"
              >查看
            </el-button>
            <el-button type="text" size="mini" @click="cancel">取消</el-button>
          </span>
          <el-button
            type="text"
            size="mini"
            v-else
            @click="checkModel(scope.row)"
            >检测
          </el-button>
          <!--<el-button type="primary" size="mini">迭代</el-button>-->
        </span>
        <span v-else>无模型产出</span>
      </template>
    </vvTable>
    <el-dialog
      custom-class="dialog"
      v-if="taskModalShow"
      :visible.sync="taskModalShow"
      class="new-task-container"
      ref="dialog"
    >
      <el-steps :active="stepIndex" align-center>
        <el-step title="请选择碗碟模型" description></el-step>
        <el-step title="审查标注" description></el-step>
        <el-step title="请选择基础模型" description></el-step>
      </el-steps>
      <div class="step-container">
        <div class="step step-1" v-if="stepIndex === 0">
          <el-table
            :data="dishModelList"
            tooltip-effect="dark"
            @selection-change="handleSelectChange"
            ref="multipleTable"
            height="400px"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="dish_name" label="碗碟名称" align="center">
              <template slot-scope="scope">{{
                scope.row.dish_name || "暂无名称"
              }}</template>
            </el-table-column>
            <el-table-column label="例图" align="center">
              <template slot-scope="scope">
                <!--<img :src="scope.row.dish_image_url" alt="" width="50"/>-->
                <classDishWrapper
                  :image="scope.row"
                  class="class-dish-wrapper"
                ></classDishWrapper>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="step step-2" v-if="stepIndex === 1">
          <el-date-picker
            class="date-picker"
            :clearable="false"
            @change="getMarkData"
            v-model="taskForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <div class="count">
            <el-table
              :data="markedImageList"
              style="width: 80%; margin: 0 auto"
              height="500px"
            >
              <el-table-column label="碗碟id(暂用)" align="center">
                <template slot-scope="scope">
                  <!--<img :src="scope.row.dish_url" width="50" alt=""/>-->
                  <classDishWrapper
                    :image="scope.row"
                    class="class-dish-wrapper"
                  ></classDishWrapper>
                </template>
              </el-table-column>
              <el-table-column
                prop="count"
                label="已标注图片个数"
                align="center"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  label="总数"
                >
                  <template slot-scope="scope">
                    {{
                      taskForm.ex_dish_uuid_list.indexOf(
                        scope.row.class_uuid
                      ) !== -1
                        ? scope.row.marked_img_list.length
                        : scope.row.marked_img_list.length +
                            scope.row.migration_count || 0
                    }}
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="迁移数据"
              >
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="useMigarition(scope.row)"
                    v-if="
                      taskForm.ex_dish_uuid_list.indexOf(
                        scope.row.class_uuid
                      ) !== -1
                    "
                    >使用</el-button
                  >
                  <el-button
                    type="danger"
                    size="mini"
                    v-else
                    @click="unUseMigarition(scope.row)"
                    >取消使用</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="step step-3" v-if="stepIndex === 2">
          <el-table
            :data="baseModelFilterByDateTime"
            style="width: 100%"
            height="500px"
          >
            <el-table-column label="结束时间" align="center">
              <template slot-scope="scope">{{
                tsTodatetime(scope.row.model_ts)
              }}</template>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="备注">
              <template slot-scope="scope">{{
                scope.row.task_desc ? scope.row.task_desc : "无备注"
              }}</template>
            </el-table-column>
            <el-table-column header-align="center" label="详情" align="center">
              <template slot-scope="scope">
                <el-popover placement="top-start" trigger="click">
                  <div>
                    此模型中的碗碟与当前本次训练已选的碗碟
                    <el-tag type="danger" v-if="differentImages.length > 0"
                      >不完全相同</el-tag
                    >
                    <el-tag type="success" v-else>完全相同</el-tag>
                  </div>
                  <div class="image-wrapper">
                    <p>
                      此模型中的碗碟
                      <el-badge
                        class="mark"
                        :value="currentModelDishs.length"
                      />
                    </p>
                    <img
                      v-for="dish in currentModelDishs"
                      :src="dish.dish_url"
                      width="40"
                      :key="dish._uuid"
                      alt
                    />
                  </div>
                  <div class="image-wrapper">
                    <p>
                      已选碗碟
                      <el-badge class="mark" :value="selectedRows.length" />
                    </p>
                    <img
                      v-for="dish in selectedRows"
                      :src="dish.dish_image_url"
                      width="40"
                      :key="dish._uuid"
                      alt
                    />
                  </div>
                  <div class="image-wrapper">
                    <p>
                      差异碗碟
                      <el-badge class="mark" :value="differentImages.length" />
                    </p>
                    <img
                      v-for="dish in differentImages"
                      :src="
                        dish.dish_image_url
                          ? dish.dish_image_url
                          : dish.dish_url
                      "
                      width="40"
                      :key="dish._uuid"
                      alt
                    />
                  </div>
                  <el-button slot="reference" @click="toggleDetail(scope.row)"
                    >详情</el-button
                  >
                </el-popover>
                <!-- <el-button type="text" >详情</el-button> -->
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  v-if="scope.row.model_uuid !== taskForm.baseModelUuid"
                  @click="handleModelSelect(scope.row)"
                  >选定</el-button
                >
                <span v-else>
                  <el-tag type="success">已选</el-tag>
                  <el-button type="text" @click="handleModelCancel(scope.row)"
                    >取消</el-button
                  >
                </span>
              </template>
            </el-table-column>
          </el-table>
          <el-form ref="taskDesc" :model="taskForm">
            <el-form-item
              prop="task_desc"
              :rules="{
                required: true,
                message: '任务备注不能为空',
                trigger: 'blur'
              }"
            >
              <el-input
                v-model="taskForm.task_desc"
                placeholder="请为训练任务添加备注"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="btn-wrapper">
        <el-tag type="success"
          >已选标准碗碟
          <el-badge class="mark" :value="taskForm.selectedDishModel.length" />
        </el-tag>
        <!--<el-tag type="success">已选图片 <el-badge class="mark" :value="taskForm.selectedDishModel.length"/></el-tag>-->
        <el-button
          size="mini"
          type="danger"
          class="btn confirm-btn"
          @click="cancelTask"
          >取消</el-button
        >
        <el-button
          type="primary"
          class="btn"
          @click="preStep"
          size="mini"
          v-if="stepIndex < 3 && stepIndex > 0"
          >上一步</el-button
        >
        <el-button
          size="mini"
          type="success"
          v-if="stepIndex === 0"
          :disabled="selectedRows.length === 0"
          @click="goChecking(true)"
          >按批次审查</el-button
        >
        <el-button
          size="mini"
          type="success"
          v-if="stepIndex === 1"
          @click="goChecking(false)"
          >按碗碟审查</el-button
        >
        <el-button
          size="mini"
          type="primary"
          class="btn"
          @click="nextStep"
          v-if="stepIndex < 3"
          :disabled="selectedRows.length === 0"
          >下一步</el-button
        >
        <el-button
          size="mini"
          type="primary"
          class="btn confirm-btn"
          @click="newTask"
          v-if="stepIndex === 3"
          >开始训练</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="正在运行的训练任务"
      :visible.sync="trainingTaskShow"
      width="60%"
    >
      <el-table :data="trainingTaskList" style="width: 100%">
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="#"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="task_uuid"
          label="ID"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eatery_name"
          label="食堂"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="canteen_name"
          label="餐厅"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="生成时间">
          <template slot-scope="scope">{{
            tsTTodate(scope.row.start_ts)
          }}</template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="viewUnderCanteen(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      title="请上传测试小图"
      :visible.sync="checkDialogShow"
      width="30%"
      list-type="picture-card"
    >
      <div class="image-item" v-for="image in checkImageIlist" :key="image">
        <img :src="image" alt width="100" />
      </div>
      <el-upload
        class="upload-demo"
        action
        :http-request="handleUpload"
        :show-file-list="false"
        multiple
      >
        <span class="btn">
          <i class="el-icon-plus"></i>
        </span>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCheck">取 消</el-button>
        <el-button type="primary" @click="goCheckModel(false)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="请选择需要检测的批次"
      :visible.sync="backDataDialogCheck"
      width="60%"
    >
      <el-table
        :data="backDataByCanteen"
        height="500px"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          :selectable="selectable"
          header-align="center"
          align="center"
          prop="columnProp"
          type="selection"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="label_task_ts"
          label="回测日期"
        >
          <template slot-scope="scope">{{
            tsTodatetime(scope.row.label_task_ts)
          }}</template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="img_count"
          label="图片个数"
        >
          <template slot-scope="scope">{{ scope.row.img_count || 0 }}</template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="审查状态">
          <template slot-scope="scope">
            <el-tag
              type="success"
              v-if="scope.row.check_state === '1'"
              size="mini"
              >已审查</el-tag
            >
            <el-tag type="danger" v-else size="mini">未审查</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="columnProp"
          label="关系"
        >
          <template slot-scope="scope">
            <el-tag
              type="success"
              v-if="scope.row.is_trained === '1'"
              size="mini"
              >已在训练集</el-tag
            >
            <el-tag type="danger" size="mini" v-else>未在训练集</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCheck" size="mini">取 消</el-button>
        <el-button type="primary" @click="goCheckModel(true)" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="模型检测结果" :visible.sync="checkResultShow" width="30%">
      <span>模型检测结果</span>
      <div class="image-wrapper">
        <div
          class="image-item-wrapper image-item-wrapper-1"
          v-for="dish in checkResult"
          :key="dish.img_url"
        >
          <img :src="dish.img_url" alt width="100" />
          <div>
            所属例图: {{ dish.dish_name }}
            <img :src="dish.dish_url" alt width="50" />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkResultShow = false" size="mini"
          >取 消</el-button
        >
        <el-button type="primary" @click="checkResultShow = false" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import {
  apiCheckModel,
  apigetDetailByModelId,
  apiGetImageByUUID,
  apiGetMarkDataCount,
  apiGetTask,
  apiGetTrainedModelList,
  apiNewTask,
  apiQueryTaskByCanteen,
  apiSelectTrainAcc,
  apiStopTask,
  apiTrainModelCheckResult
} from '@/api';

import moment from 'moment';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import util from '@/lib/util';
import {errorMessage, successMessage} from '../../lib/msg';
import filterWrapper from '_c/filterWrapper';
import classDishWrapper from '_c/classDishWrapper';
import aliOssUpload from '@/lib/aliOSSUpload';
import md5 from 'js-md5';
import vvTable from 'vue-virtual-table';
import {tableHeight} from '_v/mixin';

function dateToUnixtimestamp(dateObj, time) {
  // 时间戳
  // return dateObj.getTime() / 1000;
  return (
    new Date(new Date(dateObj).setHours(0, 0, 0, 0)) / 1000 + time * 3600 * 24
  );
}

export default {
  name: "trainTask",
  components: {
    filterWrapper,
    classDishWrapper,
    vvTable
  },
  data() {
    function getDateRange() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 6);
      return [start, end];
    }
    return {
      tableConfig: [
        { prop: "_index", name: "id", width: 50 },
        { prop: "dateTime", name: "创建时间" },
        { prop: "_action", name: "状态", actionName: "status_slot" },
        { prop: "_action", name: "进度", actionName: "cmd_status_slot" },
        { prop: "_action", name: "备注", actionName: "task_desc_slot" },
        { prop: "_action", name: "准确率", actionName: "acc_slot", width: 200 },
        { prop: "_action", name: "例图", actionName: "class_list_slot" },
        { prop: "_action", name: "操作", actionName: "action_slot" }
      ],
      selectedBackDataRows: [],
      label_task_info_list: [],
      checkProcess: false,
      onlyHaveModelTasks: false,
      trainingTaskList: [],
      trainingTaskShow: false,
      task_desc: "",
      imageData: [],
      loading: false,
      checkResultShow: false,
      checkResult: {},
      refreshFlag: false,
      fullScreenLoading: false,
      activeLine: 0,
      count: 0,
      markedImageList: [],
      baseModelList: [],
      stepIndex: 0,
      taskList: [],
      taskModalShow: false,
      selectedRows: [], // 选中的模型
      canteenList: [],
      pauseTaskBtn: false,
      taskForm: {
        selectedDishModel: [],
        dateRange: getDateRange(),
        baseModelUuid: "",
        task_desc: "",
        ex_dish_uuid_list: []
      },
      currentModelDishs: [],
      checkImageIlist: [],
      checkDialogShow: false,
      backDataDialogCheck: false,
      checkedRow: null
    };
  },
  mounted() {
    // document.body.appendChild(this.$refs.dia)
    this.setSubTitle("新建训练任务");
    let that = this;
    this.getCurrentTask();
    if (this.$route.params && this.$route.params.selfCheck) {
      this.taskForm = this.taskFormData.taskForm;
      this.stepIndex =
        this.taskFormData.stepIndex === 0 ? 1 : this.taskFormData.stepIndex;
      this.selectedRows = this.taskFormData.selectedRows;
      this.taskModalShow = true;
    }
    this.getTrainedModelList();
    // this.getTraingTask()
  },
  filters: {},
  methods: {
    ...mapMutations([
      "emitLoading",
      "removeLoading",
      "setSubTitle",
      "setTaskFormData",
      "cachedDishList",
      "setCheckingTaskUUid",
      "removeCheckingTaskUUid",
      "resetTaskUUIDForTrainList"
    ]),
    ...mapActions(["setListQuery"]),
    btnActive(row) {
      return !!this.$_.find(this.selectedRows, a => a.class_id === row.class_id);
    },
    useMigarition(row) {
      let idx = this.taskForm.ex_dish_uuid_list.indexOf(row.class_uuid);
      if (idx !== -1) {
        this.taskForm.ex_dish_uuid_list.splice(idx, 1);
      }
    },
    unUseMigarition(row) {
      this.taskForm.ex_dish_uuid_list.push(row.class_uuid);
    },
    selectable(row) {
      return row.check_state === "1";
    },
    cancel() {
      if (!this.checkProcess) {
        this.removeCheckingTaskUUid();
      }
      this.$confirm(
        "检测进程还在运行, 此时停止并不会杀掉检测进程, 是否取消检测?",
        "提示",
        {
          cancelButtonText: "cancel",
          confirmButtonText: "确定取消"
        }.then(() => {
          this.removeCheckingTaskUUid();
          // this.$message.error('')
        })
      );
    },
    async viewResult(row) {
      let { task_uuid } = row;
      this.checkProcess = true;
      try {
        let res = await apiTrainModelCheckResult(task_uuid);
        // return res
        // console.log(res);
        let { img_info_list, dish_acc_list, dif_img_info_list } = res;
        this.checkProcess = false;
        // this.removeCheckingTaskUUid()
        this.$router.push({
          name: "checkResult",
          params: {
            img_info_list,
            dish_acc_list,
            dif_img_info_list,
            classList: row.classList
          }
        });
      } catch (e) {
        if (e.message === "-1") {
          this.$message.error("检测还未完成, 请等待");
        } else {
          this.$message.error("查询失败" + e.message);
        }
      }
    },
    computedState(row) {},
    isChecking(taskUUID) {
      // console.log(this.checkingTaskUUID, taskUUID );
      // // console.log(this.$_.find(this.checkingTaskUUID, taskUUID ) !== undefined);
      // return this.$_.find(this.checkingTaskUUID, (a) => taskUUID === a) !== undefined
      return taskUUID === this.checkingTaskUUID;
    },
    tsTTodate(ts) {
      return moment(ts * 1000).format("YYYY年MM月DD日 HH:mm");
    },
    viewUnderCanteen(row) {
      let canteen = {
        canteen_name: row.canteen_name,
        canteen_id: Number(row.canteen_id)
      };
      let eatery = {
        eatery_name: row.eatery_name,
        eatery_id: Number(row.eatery_id)
      };
      let listQuery = this.listQuery;
      listQuery.canteen = canteen;
      listQuery.eatery = eatery;
      this.setListQuery(listQuery);
      this.$store.dispatch("setCanteenList", { isSearch: true });
      this.trainingTaskShow = false;
    },
    sorted(list) {
      return list.sort((a, b) => {
        return a.class_id - b.class_id;
      });
    },
    cancelCheck() {
      this.checkImageIlist = [];
      this.checkDialogShow = false;
      this.backDataDialogCheck = false;
    },
    handleSelectionChange(rows) {
      // console.log(rows);
      this.selectedBackDataRows = rows;
      // let images = rows.map(a => {
      //   return a.img_info_list.map(b => {
      //     if (!b.hasOwnProperty("img_url")) {
      //       return;
      //     }
      //     return b.img_url;
      //   });
      // });
      // console.log(images);
      // this.checkImageIlist = this.$_.uniq(this.$_.flatten(images));
    },
    async goCheckModel(task) {
      // let checkedList = this.$_.deepClone(this.checkImageIlist)
      let label_task_uuid_list = [];
      let img_url_list = [];
      console.log(task);
      if (task === true) {
        label_task_uuid_list = this.selectedBackDataRows.map(
          a => a.label_task_uuid
        );
        img_url_list = false;
      } else {
        img_url_list = this.checkImageIlist;
        label_task_uuid_list = false;
      }
      try {
        this.fullScreenLoading = true;
        let res = await apiCheckModel({
          label_task_uuid_list,
          model_uuid: this.checkedRow.trainModel.model_uuid,
          img_url_list,
          canteen_id: this.listQuery.canteen.canteen_id
        });
        this.fullScreenLoading = false;
        this.cancelCheck();
        this.setCheckingTaskUUid(this.checkedRow.task_uuid);
        this.$message.warning("正在检测中, 请稍候");
      } catch (e) {
        this.$message.error("检测出错" + e.message);
        this.fullScreenLoading = false;
        this.cancelCheck();
        console.log(e);
      }
    },
    async handleUpload(options) {
      let file = options.file;
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = async e => {
        let md5key = md5(e.target.result);
        try {
          let { url } = await aliOssUpload(
            {
              bucket: "dish-model-test",
              prefix: "zx-modelcheck-img",
              name: md5key
            },
            file
          );
          this.checkImageIlist.push(url);
        } catch (e) {
          console.log(e);
          this.$message.error("上传图片到到里云失败");
        }
      };
    },
    handleClose() {},
    checkModel(row) {
      this.$confirm("请选择测试来源", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "回测图片",
        cancelButtonText: "本地图片"
      })
        .then(async () => {
          this.checkedRow = row;
          this.fullScreenLoading = true;
          // fix 按照批次检测, 获取批次信息, 是否在此次训练中
          // try {
          //   let res = await apiGetbackDataByCanteen(
          //     this.listQuery.canteen.canteen_id
          //   );
          //   this.imageData = res.img_data || [];
          //   this.fullScreenLoading = false;
          //   this.backDataDialogCheck = true;
          // } catch (e) {
          //   this.fullScreenLoading = false;
          //   this.$message.error("回测数据列表获取失败");
          // }
          // this.$confirm('')
          try {
            let res = await apiQueryTaskByCanteen(
              this.listQuery.canteen.canteen_id,
              row.task_uuid
            );
            console.log(res);
            this.label_task_info_list = res.label_task_info_list || [];
            this.fullScreenLoading = false;
            this.backDataDialogCheck = true;
          } catch (e) {
            this.fullScreenLoading = false;
            this.$message.error("回测数据列表获取失败");
          }
        })
        .catch(action => {
          if (action !== "cancel") {
            this.$message.error("您已取消");
          } else {
            this.checkedRow = row;
            this.checkDialogShow = true;
          }
        });
    },
    goChecking(byBatch = false) {
      this.setTaskFormData({
        taskForm: this.taskForm,
        stepIndex: this.stepIndex,
        selectedRows: this.selectedRows
      });
      if (byBatch) {
        this.cachedDishList(this.selectedRows);
        this.resetTaskUUIDForTrainList();
        this.$router.push({
          name: "taskHistoryByBatch"
        });
        // return this.$message.error('正在开发')
      } else {
        this.$router.push({
          name: "imageCheckBeforeNewTask",
          params: {
            data: this.markedImageList
          }
        });
      }
    },
    refresh() {
      this.getCurrentTask();
      this.getTrainedModelList();
    },
    async selectAcc(row) {
      let res = await this.$confirm(
        "本训练任务还在运行中, 是否发布此模型?",
        "提示",
        {
          confirmButtonText: "发布",
          cancelButtonText: "取消"
        }
      ).catch(() => {
        this.$message.error("您已取消");
      });
      console.log(res);
      let accKey = Object.keys(row)[0];
      try {
        await apiSelectTrainAcc(accKey);
        this.getCurrentTask();
      } catch (e) {
        console.log(e);
      }
    },
    clearChosenBaseModel() {
      this.taskForm.baseModelUuid = "";
    },
    cancelTask() {
      this.taskForm = {
        selectedDishModel: [],
        dateRange: [new Date(), new Date()],
        baseModelUuid: "",
        ex_dish_uuid_list: []
      };
      this.resetTaskUUIDForTrainList();
      this.stepIndex = 0;
      this.taskModalShow = false;
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 6);
      this.taskForm.dateRange = [start, end];
    },
    async toggleDetail(row) {
      console.log(row);
      let res = await apiGetImageByUUID(row.model_uuid);
      this.currentModelDishs = res.dish_info_list;
    },
    handleModelSelect(row) {
      if (row.model_uuid === this.taskForm.baseModelUuid) {
        errorMessage("该条目已被选择");
      } else {
        this.taskForm.baseModelUuid = row.model_uuid;
      }
    },
    handleModelCancel() {
      this.taskForm.baseModelUuid = "";
    },
    preStep() {
      if (this.stepIndex > 0) {
        this.stepIndex -= 1;
      }
    },
    nextStep() {
      if (this.stepIndex === 2 && this.taskForm.task_desc === "") {
        return this.$message.error("请输入任务备注");
        // this.$refs['taskDesc'].validate((valid) => {
        //   console.log();
        //   if (valid) {
        //     alert('submit!');
        //   } else {
        //     console.log('error submit!!');
        //     return false;
        //   }
        // })
      }
      this.stepIndex += 1;
    },
    handleSelectChange(rows) {
      let selectedDishModel = rows.map(row => row.class_id);
      this.selectedRows = rows;
      this.taskForm.selectedDishModel = selectedDishModel;
      // this.$set(this.taskForm, 'selectedDishModel', selectedDishModel)
    },
    // 查询模型标注的个数
    async getMarkData() {
      console.log("sadsadddddddddddddddddddddddddddddddsadsa");
      this.fullScreenLoading = true;
      this.refreshFlag = false;
      try {
        let res = await apiGetMarkDataCount({
          label_task_uuid_list: this.taskUUIDForTrainList,
          dishUUIDList: this.taskForm.selectedDishModel,
          date_range: {
            start_ts: dateToUnixtimestamp(this.taskForm.dateRange[0], 0),
            end_ts: dateToUnixtimestamp(this.taskForm.dateRange[1], 1)
          },
          canteen_id: this.listQuery.canteen.canteen_id,
          ex_dish_uuid_list: this.taskForm.ex_dish_uuid_list
        });
        this.markedImageList = res.img_list;
        this.count = res.data.count;
        this.fullScreenLoading = false;
      } catch (e) {
        this.fullScreenLoading = false;
      }
    },
    // 暂停任务
    pauseTask(scope, e) {
      let task_uuid = scope.row.task_uuid;
      this.$confirm("任务停止之后将不可恢复,是否停止?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(async () => {
          await apiStopTask({ task_uuid, api_key: this.api_key });
          this.pauseTaskBtn = true;
          this.getCurrentTask();
        })
        .catch(e => {
          console.log(e);
          this.$message({
            type: "error",
            message: "您已取消"
          });
        });
    },
    // 查询训练任务
    async getCurrentTask() {
      this.emitLoading();
      let { task_list } = await apiGetTask({
        canteen_id: this.listQuery.canteen.canteen_id,
        api_key: this.api_key
      });
      if (task_list.length > 0) {
        this.taskList = task_list.map(task => {
          this.$set(
            task,
            "dateTime",
            util.formatTime(new Date(task.task_create_ts * 1000))
          );
          return task;
        });
      } else {
        this.taskList = [];
      }
      this.removeLoading();
    },
    async newTask() {
      this.taskModalShow = false;
      this.emitLoading();
      // todo: 移动到then
      this.stepIndex = 0;
      try {
        let res = await apiNewTask({
          canteen_id: this.listQuery.canteen.canteen_id,
          label_task_uuid_list: this.taskUUIDForTrainList || [],
          collect_time_range: {
            start_ts: dateToUnixtimestamp(this.taskForm.dateRange[0], 0),
            end_ts: dateToUnixtimestamp(this.taskForm.dateRange[1], 1)
          },
          class_id_list: this.taskForm.selectedDishModel,
          base_model_uuid: this.taskForm.baseModelUuid,
          task_desc: this.taskForm.task_desc,
          ex_dish_uuid_list: this.taskForm.ex_dish_uuid_list
        });
        this.removeLoading();
        if (res === true) {
          this.getCurrentTask();
          successMessage("新建任务成功");
        } else {
          successMessage("新建任务失败, 未选择新增数据");
        }
        this.cancelTask();
      } catch (e) {
        this.removeLoading();
        this.cancelTask();
        errorMessage("新建失败" + e.message);
      }
    },
    async getTrainedModelList() {
      this.emitLoading();
      try {
        let res = await apiGetTrainedModelList({
          canteen_id: this.listQuery.canteen.canteen_id,
          api_key: this.api_key
        });
        this.removeLoading();
        this.baseModelList = res.model_list;
        this.baseModelList.forEach(a => {
          apigetDetailByModelId(a.model_uuid)
            .then(data => {
              if (data.state_code === 0) {
                this.$set(a, "classList", data.data.dish_info_list);
              } else {
                this.$set(a, "classList", []);
              }
            })
            .catch(e => {
              console.log(e);
            });
        });
      } catch (e) {
        this.removeLoading();
        this.baseModelList = [];
        // errorMessage(e)
      }
    },
    tsTodatetime(ts) {
      // return util.formatTime(ts);
      return moment(ts * 1000).format("YYYY-MM-DD :mm");
    }
  },
  computed: {
    ...mapGetters(["taskFormData", "checkingTaskUUID", "taskUUIDForTrainList"]),
    // taskUUIDForTrainListFlatten () {
    //   return this.$_.flatten(taskUUIDForTrainList)
    // },
    tableHight() {
      return tableHeight(50);
      // const clientHeight = window.innerHeight;
      // return clientHeight - 100;
    },
    differentImages() {
      if (this.currentModelDishs.length > this.selectedRows.length) {
        return this.$_.differenceWith(
          this.currentModelDishs,
          this.selectedRows,
          (left, right) => {
            return left.dish_uuid === right.class_id;
          }
        );
      } else {
        return this.$_.differenceWith(
          this.selectedRows,
          this.currentModelDishs,
          (left, right) => {
            return left.class_id === right.dish_uuid;
          }
        );
      }
    },
    backDataByCanteen() {
      return this.label_task_info_list.sort((a, b) => {
        return b.label_task_ts - a.label_task_ts;
      });
      // return [
      //   {
      //     day_ts: 1545926400,
      //     img_info_list: [
      //       {class_id: "c98ada38-bc9f-4889-b964-54b7beca1e32", img_uuid: "4ec00637-daf9-41d8-b59c-4d8d5ab85d34"}
      //     ]
      //   },
      //   {
      //     day_ts: 1545926402,
      //     img_info_list: [
      //       {class_id: "c98ada38-bc9f-4889-b964-54b7beca1e32", img_uuid: "4ec00637-daf9-41d8-b59c-4d8d5ab85d34"},
      //       {class_id: "c98ada38-bc9f-4889-b964-54b7beca1e32", img_uuid: "4ec00637-daf9-41d8-b59c-4d8d5ab85d34"}
      //     ]
      //   },
      //   {
      //     day_ts: 1545926403,
      //     img_info_list: [
      //       {class_id: "c98ada38-bc9f-4889-b964-54b7beca1e32", img_uuid: "4ec00637-daf9-41d8-b59c-4d8d5ab85d34"},
      //       {class_id: "c98ada38-bc9f-4889-b964-54b7beca1e32", img_uuid: "4ec00637-daf9-41d8-b59c-4d8d5ab85d34"},
      //       {class_id: "c98ada38-bc9f-4889-b964-54b7beca1e32", img_uuid: "4ec00637-daf9-41d8-b59c-4d8d5ab85d34"}
      //     ]
      //   },
      // ].sort((a, b) => {
      //   return  - a.day_ts + b.day_ts
      // })
    },
    selfCheck() {
      if (this.$route.params && this.$route.params.selfCheck) {
        return this.$route.params.selfCheck;
      } else {
        return false;
      }
    },
    dishModelList() {
      return this.$store.getters.modelList;
    },
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 3);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近半年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 6);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      };
    },
    api_key() {
      return this.$store.getters.userinfo().api_key;
    },
    taskFilterByDateTime() {
      let taskList = this.taskList;
      let modelList = this.baseModelList;
      taskList.forEach(a => {
        let res = this.$_.find(modelList, b => {
          return b.task_uuid === a.task_uuid;
        });
        if (res) {
          this.$set(a, "trainModel", res);
        } else {
          this.$set(a, "trainModel", null);
        }
      });
      let arr = [];
      if (this.onlyHaveModelTasks) {
        arr = this.taskList.filter(a => a.trainModel);
      } else {
        arr = this.taskList;
      }
      return arr.sort((b, a) => {
        return a.task_create_ts - b.task_create_ts;
      });
    },
    baseModelFilterByDateTime() {
      return this.baseModelList.sort((a, b) => b.model_ts - a.model_ts);
    },
    ...mapState({
      listQuery(state) {
        return state.filterWrapper.listQuery;
      }
    }),
    selectedDishModel() {
      return this.taskForm.selectedDishModel;
    }
  },
  watch: {
    // taskModalShow (val) {
    //   if (!val) {
    //     this.ex_dish_uuid_list = []
    //     this.selectedRows = []
    //   }
    // },
    taskModalShow(val) {
      if (!val) {
        this.cancelTask;
      }
    },
    $route: {
      // handler (val) {
      //   console.log(`ssssssssssssssss`, val);
      //   if (val.query.selfCheck === true) {
      //       this.taskForm = this.taskFormData.taskForm
      //       this.stepIndex =  this.taskFormData.stepIndex
      //       this.taskModalShow = true;
      //   }
      // }, deep: true
    },
    selectedDishModel: {
      handler() {
        this.refreshFlag = true;
      },
      deep: true
    },
    listQuery: {
      handler() {
        this.getCurrentTask();
        this.getTrainedModelList();
      },
      deep: true
    },
    stepIndex() {
      if (this.stepIndex === 0) {
        this.$nextTick(() => {
          if (this.taskModalShow && this.selectedRows.length > 0) {
            this.selectedRows.forEach(row => {
              this.$refs["multipleTable"].toggleRowSelection(row);
            });
          }
          console.log(this.$refs);
        });
      }
      if (this.stepIndex === 1) {
        this.getMarkData();
      } else if (this.stepIndex === 2) {
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .table-expand {
    font-size: 0;
  }

  .table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
}
</style>
<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>
.container {
  position: relative;
  .btn-wrapper-1 {
    top: -35px;
  }
  .upload-demo {
    display: inline-block;
    width: 100px;
    height: 100px;
    font-size: 50px;
    color: #409eff;
    line-height: 100px;
    text-align: center;
  }

  .image-item {
    display: inline-block;
  }
  .image-item-wrapper {
    display: inline-block;
    width: 50px;
    height: 50px;

    .image-item {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }

    &.image-item-wrapper-1 {
      display: inline-block;
      width: 100px;
      height: 100px;
    }
  }

  .dialog {
    .btn-wrapper {
      text-align: right;
      padding: 5px;

      .btn {
        display: inline-block;
      }
    }
  }
}

.step-2 {
  text-align: center;

  .date-picker {
    display: inline-block;
  }
}
.class-dish-wrapper {
  display: inline-block;
  width: 50px;
  height: 50px;
}
.image-wrapper {
  border: 1px solid #aaa;
  padding: 5px;
  margin: 5px;
}
.image-item-wrapper-2 {
  display: inline-block;
  width: 50px;
  height: 50px;

  .image-item {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
  &.image-item-wrapper-1 {
    display: inline-block;
    width: 100px;
    height: 100px;
  }
}
</style>
